import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { showBackendMessage } from "../helpers/messagesHelper";
import Messages from "../localization/Messages";
import { getAllowedMimeTypes, getAllowedMimeTypesLD } from "../../src/api/document";
import { FetchFunctionResult, useFetch } from "./useFetch";
import { Roles } from "../../src/models/userData";
import { useAuth } from "../../src/hooks/useAuth";

/**
 * Custom hook for fetching allowed MIME types.
 *
 * @returns An array of allowed MIME types.
 */
export function useFetchAllowedMimeTypes(): FetchFunctionResult<string[]> {
    const dispatch = useDispatch();
    const intl = useIntl();

    const { hasRole } = useAuth();
    const isDispatcher = hasRole(Roles.PASSENGER_CABIN_CRUISES_DISPATCHER);
    const isOnCallUser = hasRole(Roles.ON_CALL_DISPATCHER);
    const isLDUser = hasRole(Roles.LOCKS_AND_DOCKS_DISPATCHER);

    const apiFn =
        isDispatcher || isOnCallUser
            ? getAllowedMimeTypes
            : isLDUser
              ? getAllowedMimeTypesLD
              : null;

    const { data, loading, refetch } = useFetch<string[]>({
        fetchFn: async () => {
            if (!apiFn) return [];
            try {
                const apiResponse = await apiFn();
                return apiResponse.data ?? [];
            } catch {
                dispatch(showBackendMessage(intl, "error", "fetching", Messages.allowedMimeTypes));
                return [];
            }
        },
        fetchDeps: [],
    });

    return { data, loading, refetch };
}
